class CommonService {
    /*@ngInject*/
    constructor($log, $http, $rootScope) {
        this.$log = $log;
        this.$http = $http;
        this.$rootScope = $rootScope;
        this.personalizeRequestResponse = null;
        this.baseUrl = ACC.config.encodedContextPath;
    }

    // FIXME: async function and getPersonalizeRequestResponse is called several times sync. Use promise (see SERMA?)
    personalRequest() {
        this.$log.debug('sending personalize request');

        let url = this.getBaseUrl() + '/personalize';

        this.$http.get(url, null)
            .then((response) => {
                if (response.status >= 500) {
                    this.$log.error('personalize request error: ' + response.status + ' ' + response.statusText);
                    window.location.replace('/');
                } else if (response.status >= 400) {
                    this.$log.error('personalize request not found: ' + response.status + ' ' + response.statusText);
                    window.location.replace('/');
                } else if (response.status >= 300) {
                    window.location.replace(response.headers['Location']);
                } else {
                    this.personalizeRequestResponse = response.data;
                    this.redirectIfRequired(this.personalizeRequestResponse.path);
                    this.dynamicYieldLoginEvent(this.personalizeRequestResponse.dyLoginTrackingData);
                    this.dynamicYieldSignUpEvent(this.personalizeRequestResponse.dySignUpTrackingData);
                    // info for algolia
                    window.algoliaEncodedEmail = this.personalizeRequestResponse.encodedEmail;
                    ACC.customer.isHardLoggedIn = this.personalizeRequestResponse.isHardLoggedIn;
                    ACC.customer.isSoftLoggedIn = !this.personalizeRequestResponse.isHardLoggedIn && this.personalizeRequestResponse.isLoggedIn;
                    // https://usercentrics.com/docs/web/features/api/control-functionality/
                    if (window.__ucCmp) {
                        window.__ucCmp.isInitialized().then((data) => {
                            if (data) {
                                this.putDataIntoEshopDatalayer();
                            } else {
                                console.warn('Something went wrong');
                            }
                        });
                    } else {
                        window.addEventListener('google-analytics-consent', () => {
                            this.putDataIntoEshopDatalayer();
                        }, {once: true});
                    }
                    this.$rootScope.$broadcast('personalizeRequestSuccess');
                }
            }, (error) => {
                this.$log.error('personalize request: ' + error.status + ' ' + error.statusText);
            });
    }

    putDataIntoEshopDatalayer() {
        try {
            window.__ucCmp.getConsentDetails().then((data) => {
                let services = data.services;
                Object.values(services).forEach(value => {
                    if (value.name == 'Google Analytics') {
                        if (value.consent.given) {
                            window.dataLayer = window.dataLayer || [];
                            window.dataLayer.push({
                                'event': 'personalizeRequestSuccess',
                                'hashed_email': this.personalizeRequestResponse.encodedEmail,
                                'member_id': this.personalizeRequestResponse.memberId,
                                'cartEntries': this.personalizeRequestResponse.cartEntries,
                            });
                            window.dispatchEvent(new CustomEvent('personalize-tracking', {
                                detail: {
                                    hashed_email: this.personalizeRequestResponse.encodedEmail,
                                    member_id: this.personalizeRequestResponse.memberId,
                                }
                            }));
                        } else {
                            this.$log.debug('No consent for Google Analytics');
                        }
                    }
                });
            })
        } catch (e) {
            this.$log.error(e);
        }
    }

    dynamicYieldLoginEvent(dyLoginTrackingData) {
        const dyLoginEval = function () {
            if (typeof DY === 'object' && typeof DY.API === 'function') { // DY.API() is available?
                DY.API("event", {
                    name: "Login",
                    properties: {
                        dyType: dyLoginTrackingData.dyType,
                        hashedEmail: dyLoginTrackingData.hashedEmail
                    }
                });
                return true;
            } else {
                return false;
            }
        };

        if (dyLoginTrackingData !== null) {
            if (!dyLoginEval()) {
                const dyLoginInterval = setInterval(function () {
                    if (dyLoginEval()) { // remove the interval once the DY.API was available
                        clearInterval(dyLoginInterval);
                    }
                }, 1000);
            }
        }
    }

    dynamicYieldSignUpEvent(dySignUpTrackingData) {
        if (dySignUpTrackingData !== null) {
            try {
                if (typeof DY != "undefined") {
                    DY.API("event", {
                        name: "Signup",
                        properties: {
                            dyType: dySignUpTrackingData.dyType,
                            hashedEmail: dySignUpTrackingData.hashedEmail
                        }
                    });
                }
            } catch (e) {
                console.warn("can't send DY signup event");
            }
        }
    }

    getPersonalizeRequestResponse() {
        return this.personalizeRequestResponse;
    }

    /**
     * Returns base url without trailing slash
     *
     * @return {string} base url
     */
    getBaseUrl() {
        return this.baseUrl;
    }

    redirectIfRequired(extendedCountryCode) {
        if (extendedCountryCode === undefined || extendedCountryCode === null) {
            window.location.replace('/');
        } else if (!window.location.pathname.startsWith('/' + extendedCountryCode)) {
            window.location.replace('/' + extendedCountryCode);
        }
    }
}

export default CommonService;
